import { app } from '../../../../../app';
import { Controller } from './assigned-groups.controller';

app.component('assignedGroups', {
    bindings: {
        application: '<',
        companyId: '<',
        groups: '<',
    },
    controller: Controller,
    templateUrl: require('./assigned-groups.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/assigned-groups/assigned-groups.component.js